import React from 'react';
import './style.css';
import icon_1 from "../../../assets/img/Ship/policy_1.png";
import icon_2 from "../../../assets/img/Ship/policy_2.png";
import icon_3 from "../../../assets/img/Ship/policy_3.png";
import icon_4 from "../../../assets/img/Ship/policy_4.png";

function Ship() {
    return (
        <div className="d-flex justify-content-between align-items-center pt-5">
            <div className="ship_item d-flex justify-content-center align-items-center w-25">
                <img src={icon_1} alt="icon" className="me-3" />

                <div>
                    <p className="mb-2">Free Shipping</p>
                    <p className="t-gray">Order over $100</p>
                </div>
            </div>

            <div className="ship_item d-flex justify-content-center align-items-center w-25">
                <img src={icon_2} alt="icon" className="me-3" />

                <div>
                    <p className="mb-2">Support 24/7</p>
                    <p className="t-gray">Before & After Purchase</p>
                </div>
            </div>

            <div className="ship_item d-flex justify-content-center align-items-center w-25">
                <img src={icon_3} alt="icon" className="me-3" />

                <div>
                    <p className="mb-2">Money Back</p>
                    <p className="t-gray fw">If you don't Satistied</p>
                </div>
            </div>

            <div className="ship_item d-flex justify-content-center align-items-center w-25">
                <img src={icon_4} alt="icon" className="me-3" />

                <div>
                    <p className="mb-2">Gift Vouvher</p>
                    <p className="t-gray fw">There are many variations</p>
                </div>
            </div>
        </div>
    );
}

export default Ship;